import { IMobileAccess, IServiceStatus } from "@nju/data-access-portal-product";

export function getMobileServiceStatus(
  mobileAccess?: IMobileAccess,
): IServiceStatus["mobileServiceStatus"] {
  if (!mobileAccess) {
    return;
  }

  return mobileAccess.status;
}
